import React from 'react';
import { useGrowthBook } from '@growthbook/growthbook-react';
import { Build as MaintenanceIcon } from '@mui/icons-material';
import { MAINTENANCE_BANNER_FLAG } from 'constants/feature-flags';
import { Banner } from 'components/banner';
import { MAINTENANCE_BANNER_DISMISSED_COOKIE_NAME } from 'constants/cookies';
import { DISMISSAL_DURATIONS } from 'components/banner/constants/dismissalDurations';

export interface MaintenanceBannerConfig {
  title?: string;
  message?: string;
  buttonText?: string;
  isVisible?: boolean;
  showIcon?: boolean;
  showCloseButton?: boolean;
}

const DEFAULT_CONFIG: MaintenanceBannerConfig = {
  title: '',
  message: '',
  buttonText: '',
  isVisible: false,
  showIcon: true,
  showCloseButton: true,
};

interface MaintenanceBannerProps {
  onDismiss?: () => void;
}

const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({
  onDismiss,
}) => {
  const growthbook = useGrowthBook();
  
  const config = growthbook.getFeatureValue<MaintenanceBannerConfig>(
    MAINTENANCE_BANNER_FLAG,
    DEFAULT_CONFIG
  );

  if (!config?.isVisible || !config.message) {
    return null;
  }

  return (
    <Banner
      variant="floating"
      message={config.message}
      title={config.title}
      severity="info"
      showIcon={config.showIcon}
      icon={<MaintenanceIcon />}
      buttonText={config.buttonText}
      storageKey={MAINTENANCE_BANNER_DISMISSED_COOKIE_NAME}
      dismissalDuration={DISMISSAL_DURATIONS.ONE_DAY}
      onDismiss={onDismiss}
      testId="maintenance-banner"
    />
  );
};

export default MaintenanceBanner; 